(() => {
  if (window.LXSharedPurchaseFlow) {
    window.LXSharedPurchaseFlow.refresh();
    return;
  }
  const instances = new Map();
  const initialize = root => {
  const marker = document.querySelector('[data-lx-shared-flow-marker]');
  if (!marker || !root || root.hasAttribute('data-lx-shared-flow')) return;
  root.setAttribute('data-lx-shared-flow', '');
  root.setAttribute('data-lx-clear-flow', '');
  const accessoryNames = new Map([["SH1FNFVDYNTYUUG2A1-png","A1"],["QJEK4J5DHDZ43F5JA2-png","A2"],["LJHUAG3VBAQJCKDOA3-png","A3"],["ONIJLFIO65CHU98EA4-png","A4"],["9CJ8UHPJB5YL1MZ4A5-png","A5"],["PJI5UMAQXQGI3KGXA6-png","A6"],["P8AF622P2WAJZAC5A7-png","A7"],["TFF529B3YL3SOHQAA8-png","A8"],["DND8ZGMTYWQT7E53A9-png","A9"],["P9BMRXUOA8O2NDV6A10-png","A10"],["ZSZAY82B91EGYRF1A11-png","A11"],["F2IRCNVIV2VYL7LIA12-png","A12"],["JZP9Y7OWX1XEQ9RWA13-png","A13"],["KIO2I1E36D5GVXWGA14-png","A14"],["D6YJKV5DXP1X3K92A15-png","A15"],["RSYFTJSDKMAHAHHRA16-png","A16"],["GOW9RAKLX39RN48GA17-png","A17"],["QE62KK8KKTN8YOJNA18-png","A18"],["NMYUH7GQFKB8OCYJA19-png","A19"],["TWI855NJB2II8S5FA20-png","A20"],["QET4EG9P1NM6ZNV9A21-png","A21"],["6VU75P7AG3YVRMUJA22-png","A22"],["Z3F3YXZZ1LDBOJ9LA23-png","A23"],["S78BI4YKVO8BY86ZU-shaped-colorful-hook-and-loop-jpg","U-shaped colorful hook and loop(B)"],["8UXOO67YK9GT7JOOBall-Bead-Chain-png","Ball Bead Chain(C)"],["5HDBZW33BDIKBFHDPhone-Lanyard-jpg","Phone Lanyard（D）"],["YBZ8X12EMKWMG3KHPhone-lanyard-with-hemp-rope--E---jpg","Phone lanyard with hemp rope （E)"],["FJ9JPKBJ98QA5FQMNo-accessories-png","No accessories"]]);
  const selectionNotes = new WeakMap();
  const help = root.querySelector('.lx-artwork-help');
  const mobileNote = root.querySelector('.lx-mobile-artwork-note');
  const updateAccessoryDisplay = (accessory, label) => {
    let selectionNote = selectionNotes.get(accessory);
    if (!selectionNote) {
      selectionNote = document.createElement('div');
      selectionNotes.set(accessory, selectionNote);
      selectionNote.className = 'lx-accessory-selection';
      selectionNote.setAttribute('role', 'status');
      selectionNote.setAttribute('aria-live', 'polite');
      selectionNote.setAttribute('aria-atomic', 'true');
    }
    if (label && label.nextElementSibling !== selectionNote) label.after(selectionNote);
    const options = [...accessory.querySelectorAll('.shopify-width-height')];
    accessory.setAttribute('role', 'radiogroup');
    accessory.setAttribute('aria-label', label?.textContent.trim() || marker.dataset.accessories);
    options.forEach((option, index) => {
      const img = option.querySelector('img');
      const key = (img?.getAttribute('src') || '').split('/').pop().split('?')[0];
      const name = accessoryNames.get(key) || img?.alt?.trim() || option.title || String(index + 1);
      const short = name.match(/[（(]([BCDE])[）)]/);
      option.dataset.lxOptionLabel = short ? short[1] : name;
      option.setAttribute('role', 'radio'); option.setAttribute('aria-label', name);
      option.setAttribute('aria-checked', String(option.classList.contains('c-active-option')));
      option.tabIndex = option.classList.contains('c-active-option') || (!accessory.querySelector('.c-active-option') && index === 0) ? 0 : -1;
    });
    const active = accessory.querySelector('.c-active-option');
    if (active) { accessory.removeAttribute('data-lx-invalid'); accessory.querySelector('.lx-accessory-error')?.remove(); }
    const image = active?.querySelector('img');
    const key = (image?.getAttribute('src') || '').split('/').pop().split('?')[0];
    const openTips = [...document.querySelectorAll('.ant-tooltip:not(.ant-tooltip-hidden) .ant-tooltip-inner')];

    let name = accessoryNames.get(key);
    if (active?.classList.contains('ant-tooltip-open') && openTips.length === 1) {
      const currentName = openTips[0].textContent.trim();
      if (currentName) { name = currentName; accessoryNames.set(key, name); }
    }
    const text = active ? (name ? marker.dataset.selected + ' ' + name : marker.dataset.selectedAccessory) : marker.dataset.selectAccessory;
    if (selectionNote.textContent !== text) selectionNote.textContent = text;
    const knownNames = new Set(accessoryNames.values());
    document.querySelectorAll('.ant-tooltip').forEach(tip => {
      const nativeLabel = tip.querySelector('.ant-tooltip-inner')?.textContent.trim();
      if (knownNames.has(nativeLabel)) tip.setAttribute('data-lx-accessory-tooltip', '');
    });
  };


  const onKeydown = event => {
    const option = event.target.closest('[data-lx-option-label]');
    if (!option) return;
    const options = [...option.closest('[data-lx-flow-accessories]').querySelectorAll('[data-lx-option-label]')];
    let next;
    if (event.key === 'Enter' || event.key === ' ') next = option;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = options[(options.indexOf(option) + 1) % options.length];
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = options[(options.indexOf(option) + options.length - 1) % options.length];
    if (event.key === 'Home') next = options[0];
    if (event.key === 'End') next = options.at(-1);
    if (next) { event.preventDefault(); next.focus(); next.click(); }
  };
  root.addEventListener('keydown', onKeydown);

  const proxyAttributes = new WeakMap();
  const syncProxyButtons = () => {
    root.querySelectorAll('#shopaw-container button, #shopaw-container-block button').forEach(button => {
      if (!/^(ADD TO CART|BUY)(?:\s|$)/i.test(button.textContent.trim())) return;
      const style = getComputedStyle(button);
      const rect = button.getBoundingClientRect();
      const hiddenProxy = button.classList.contains('tw-left-[-9999px]') ||
        (style.opacity === '0' && rect.right < 0) ||
        (root.classList.contains('lx-live-tier-active') && button.classList.contains('lx-tier-duplicate-buy'));
      if (hiddenProxy) {
        if (!proxyAttributes.has(button)) {
          proxyAttributes.set(button, {tabindex: button.getAttribute('tabindex'), ariaHidden: button.getAttribute('aria-hidden')});
        }
        if (document.activeElement === button) {
          root.querySelector('product-form [name="add"]')?.focus({preventScroll:true});
        }
        if (button.getAttribute('tabindex') !== '-1') button.setAttribute('tabindex', '-1');
        if (button.getAttribute('aria-hidden') !== 'true') button.setAttribute('aria-hidden', 'true');
      } else if (proxyAttributes.has(button)) {
        const saved = proxyAttributes.get(button);
        for (const [name, value] of [['tabindex', saved.tabindex], ['aria-hidden', saved.ariaHidden]]) {
          if (value === null) button.removeAttribute(name);
          else button.setAttribute(name, value);
        }
        proxyAttributes.delete(button);
      }
    });
  };

  let frame = 0;
  let portal = root.querySelector('.lx-flow-pricing');
  const managedQuantity = Boolean(document.querySelector('[data-lx-cd-tiers], [data-lx-shaker-tiers], [data-lx-sticker-tiers]'));
  const schedule = () => { if (!frame) frame = requestAnimationFrame(arrange); };
  const arrange = () => {
    frame = 0;
    if (!root.isConnected) { cleanup(); return; }
    syncProxyButtons();
    const app = root.querySelector('lx-mobile-customization[data-lx-inline-options]');
    app?.querySelectorAll('[id$="image-swatch"]').forEach(field => {
      const label = field.querySelector('.form__label');
      if (!field.hasAttribute('data-lx-flow-accessories') && !/accessor/i.test(label?.textContent || '')) return;
      field.setAttribute('data-lx-flow-accessories', '');
      updateAccessoryDisplay(field, label);
    });
    const uploads = app ? [...app.querySelectorAll('[id$="image-upload-list"]')] : [];
    uploads.forEach(upload => upload.setAttribute('data-lx-flow-upload', ''));
    const upload = uploads[0];
    const quantity = root.querySelector('[id^="Quantity-Form-"]');
    const host = root.querySelector('ssl-os-vd');
    if (!quantity && !host) return;
    if (!portal) {
      portal = document.createElement('div');
      portal.className = 'lx-flow-pricing';
    }
    if (upload) {
      if (portal.parentElement !== upload.parentElement || portal.nextElementSibling !== upload) upload.before(portal);
    } else if (app) {
      if (app.nextElementSibling !== portal) app.after(portal);
    } else if (!portal.isConnected && quantity) {
      quantity.before(portal);
    }
    if (host && host.parentElement !== portal) {
      if (quantity && host.contains(quantity)) portal.append(quantity);
      portal.append(host);
    }
    if (!managedQuantity && quantity && !host?.contains(quantity) && quantity.parentElement !== portal) portal.prepend(quantity);
    if (help && portal.lastElementChild !== help) portal.append(help);
    if (help && mobileNote && !mobileNote.hidden) mobileNote.hidden = true;
    root.setAttribute('data-lx-shared-flow-ready', '');
  };
  const observer = new MutationObserver(schedule);
  observer.observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style']});
  observer.observe(document.body, {childList:true});
  const proxyObserver = new MutationObserver(records => {
    if (records.some(record => record.target.matches?.('#shopaw-container button, #shopaw-container-block button'))) schedule();
  });
  proxyObserver.observe(root, {subtree:true, attributes:true, attributeFilter:['tabindex','aria-hidden']});
  const cleanup = () => {
    if (frame) cancelAnimationFrame(frame);
    observer.disconnect();
    proxyObserver.disconnect();
    root.removeEventListener('keydown', onKeydown);
    instances.delete(root);
    root.removeAttribute('data-lx-shared-flow');
    root.removeAttribute('data-lx-shared-flow-ready');
  };
  instances.set(root, {schedule, cleanup});
  arrange();
  };
  const refresh = () => {
    for (const [root, instance] of instances) {
      if (!root.isConnected) instance.cleanup();
      else instance.schedule();
    }
    const root = document.querySelector('product-info');
    if (root && !instances.has(root)) initialize(root);
  };
  window.LXSharedPurchaseFlow = {refresh};
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, instance] of instances) {
      if (event.target.contains(root)) instance.cleanup();
    }
  });
  refresh();
})();

